import { useState } from "react";
import { ManufacturingTabbedSection } from "@/components/manufacturing/ManufacturingTabbedSection";
import {
  ManufacturingPricingBulkEditBody,
  ManufacturingPricingColumnsBody,
} from "./ManufacturingPricingBulkMarginsCard";
import { ManufacturingPricingMaterialsLegend } from "./ManufacturingPricingMaterialsLegend";
import type { ManufacturingPricingGridState } from "./useManufacturingPricingGrid";

type ToolsTab = "bulk" | "columns" | "settings";

type Props = {
  grid: ManufacturingPricingGridState;
};

export function ManufacturingPricingToolsCard({ grid }: Props) {
  const [tab, setTab] = useState<ToolsTab>("bulk");
  return (
    <ManufacturingTabbedSection
      tabs={[
        {
          id: "bulk",
          label: "Bulk edit",
          description: "Set one layer column across the selected SKU rows.",
        },
        {
          id: "columns",
          label: "Columns",
          description: "Add a column, or change, reorder, and move an existing one.",
        },
        {
          id: "settings",
          label: "Settings",
          description: "Saved materials totals and missing-cost notes.",
        },
      ]}
      activeTab={tab}
      onTabChange={setTab}
    >
      {tab === "bulk" ? <ManufacturingPricingBulkEditBody grid={grid} /> : null}
      {tab === "columns" ? <ManufacturingPricingColumnsBody grid={grid} /> : null}
      {tab === "settings" ? <ManufacturingPricingMaterialsLegend /> : null}
    </ManufacturingTabbedSection>
  );
}
